export default __webpack_public_path__ + "static/media/logo_multicar_rect.22bda019.png";